import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.svg';

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/services', label: 'What We Do' },
  { to: '/our-work', label: 'Our Work' },
  { to: '/contact', label: 'Contact' },
];

const LEGAL_LINKS = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/cookies', label: 'Cookies' },
];

export default function Footer() {
  return (
    <footer style={{
      padding: '40px 40px 28px', background: '#080e1c',
      borderTop: '1px solid var(--card-border)',
    }}>
      <div style={{
        maxWidth: 1100, margin: '0 auto',
        display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between',
        alignItems: 'center', gap: 18,
      }}>
        <Link to="/">
          <img src={logo} alt="KnowIT Solutions" style={{
            height: 28, width: 'auto',
          }} />
        </Link>

        <div style={{ display: 'flex', gap: 22, flexWrap: 'wrap' }}>
          {NAV_LINKS.map(l => (
            <Link key={l.to} to={l.to} style={{
              fontFamily: 'var(--font-body)', fontSize: '0.78rem', fontWeight: 400,
              color: 'var(--text-muted)', transition: 'color 0.3s', textDecoration: 'none',
            }}>
              {l.label}
            </Link>
          ))}

          {LEGAL_LINKS.map(l => (
            <Link key={l.to} to={l.to} style={{
              fontFamily: 'var(--font-body)', fontSize: '0.78rem', fontWeight: 400,
              color: 'var(--text-muted)', transition: 'color 0.3s', textDecoration: 'none',
            }}>
              {l.label}
            </Link>
          ))}
        </div>

        <p style={{
          fontFamily: 'var(--font-body)', fontSize: '0.72rem', fontWeight: 300,
          color: 'rgba(255,255,255,0.2)', width: '100%', textAlign: 'center',
          marginTop: 18, paddingTop: 18,
          borderTop: '1px solid rgba(255,255,255,0.03)',
        }}>
          © {new Date().getFullYear()} KNOW<span style={{ color: 'var(--cyan)' }}>IT</span> SOLUTIONS. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
